<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
    >
      {{ fieldDef.label }}
    </span>
  </mat-label>
  <div class="w-full" (click)="edit()" (focus)="edit()">
    @if (fieldDef.meta?.value_hidden) {
      <input #inputControl matInput [(ngModel)]="displayValue" disabled class="blurred" />
    } @else {
      <input
        #inputControl
        matInput
        currencyMask
        [(ngModel)]="value"
        [ngClass]="{ disabled: isDisabled }"
        (keyup.enter)="onBlur()"
        (blur)="onBlur()"
        [options]="currencyMaskOptions"
        [disabled]="isDisabled"
      />
    }
  </div>
</mat-form-field>
